import {gql} from 'apollo-angular';

// TODO: clear fields
export const GET_GAME_TROPHY_PROGRESS = gql`
  query GetGameTrophyProgress($schoolClassId: Int!) {
    getGameTrophyProgress(schoolClassID: $schoolClassId) {
      id
      schoolClassID
      createdAt
      entries {
        id
        percentValue
        createdAt
        finishedAt
        trophy {
          trophyName
          description
          trophyStatus
          id
        }
      }
    }
  }
`;
